import { Component, EventEmitter, input, Output } from '@angular/core';
import { Startopdracht } from '../../../succeservaring/startopdrachten.service';
import { ParkourActionComponent, ParkourBadgeComponent, ParkourIconComponent } from '@parkour/ui';
import { SlicePipe } from '@angular/common';

@Component({
  selector: 'parkour-startopdrachten',
  standalone: true,
  imports: [SlicePipe, ParkourActionComponent, ParkourIconComponent, ParkourBadgeComponent],
  templateUrl: './startopdrachten.component.html',
})
export class StartopdrachtenComponent {
  startopdrachten = input.required<Startopdracht[]>();
  @Output() startopdrachtClicked = new EventEmitter<Startopdracht>();

  onStartopdrachtClicked(opdracht: Startopdracht) {
    this.startopdrachtClicked.emit(opdracht);
  }
}
